import { LgaDto } from "./lga.dto";

export class StateDto {
    id: string;
    SiteId: string;
    ModifiedById: string;
    CreatedById: string;
    dateUpdated: Date;
    dateCreated: Date;
    Version: number;
    StateName: string;
    Abbreviation: string;
    SubscriberEmail: string;
    CountryId: string;
    SubscriberId: string;
    SubscriptionUserId: string;
    lgas: LgaDto[]
    }
